import React from 'react'
import PropTypes from 'prop-types'
import { MyChip } from '@interstellar-component'

const statusConfig = {
  'Sent to CLIK': 'primary',
  // Keyed on the DISPLAY string, so it moves with the labels in
  // @services/enquiryStatus (list rows, slider header, switcher chip) and with
  // STATUS_LABELS / PARK_REASON_LABELS in report_enquiry.repositories.js (History
  // rows, whose `status_label` is derived by the BE at read time).
  //
  // THREE KEYS FOR ONE STATUS, and none of them is fed by stored data — nothing
  // persists a label, so a renamed status re-renders old history under the new
  // name. They are here for two different reasons and only one of them expires:
  //
  //   'On Hold'          the current label for a park that is NOT about money
  //                      (parked_at_create / parked_at_dispatch), and the bucket
  //                      name for the status as a whole. Permanent.
  //   'Pending Payment'  the current label for the one park that IS about money.
  //                      Permanent.
  //   'Waiting for Quota' a ROLLING-DEPLOY key only: while old
  //                      backoffice-service pods are still serving, their
  //                      `status_label` says this, and an unmatched key renders an
  //                      unstyled chip. Safe to delete once the rename is fully
  //                      rolled out.
  'On Hold': 'warning',
  'Pending Payment': 'warning',
  'Waiting for Quota': 'warning',
  'Awaiting Form': 'warning',
  'Form Revision': 'warning',
  Verification: 'primary',
  'Admin verification': 'primary',
  'Awaiting Admin Approval': 'primary',
  'Awaiting Consent': 'warning',
  'Awaiting HR Review': 'warning',
  'Enquiry Created': 'gray',
  'Verified by HR': 'primary',
  'Verified by System': 'primary',
  'Verified by CLIK': 'success',
  'Reject by HR': 'error',
  'Reject by CLIK': 'error',
  Canceled: 'error',
  Failed: 'error',
  Completed: 'success',
}

/**
 * MySLAStatusChip component for displaying SLA status in a styled chip.
 *
 * @param {object} props - Component props.
 * @param {string} props.status - The SLA status string.
 * @returns {JSX.Element} The rendered chip component.
 */
export default function MySLAStatusChip({ status }) {
  return (
    <MyChip
      label={status}
      color={statusConfig[status] || 'gray'}
      variant="filled"
      size="sm"
      rounded="md"
      dot
    />
  )
}

MySLAStatusChip.propTypes = {
  status: PropTypes.string.isRequired,
}
